import { useEffect, useState } from "react";

// Phone-width breakpoint shared by the shells (App.tsx, MMPortal.tsx) and by mobile.css.
// Layout that cannot be expressed in CSS alone — which navigation to render, where the
// nav lives — switches on this hook; everything else is CSS variables with desktop fallbacks.
export const MOBILE_QUERY = "(max-width: 760px)";

export function useIsMobile(query: string = MOBILE_QUERY): boolean {
  const [mobile, setMobile] = useState<boolean>(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMobile(e.matches);
    setMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return mobile;
}
